export const cultureType = {
    nl: "nl-NL",
    en: "en-GB"
  };
  